export const Footer = () => {
    return (
        <footer>
            {/*Vytvořeno v PcNeu.cz*/}
        </footer>
    )
}